export default __webpack_public_path__ + "static/media/SG-DarkBlue-0002.55408549.png";